import React, { useCallback, useState, useEffect, createElement as _createElement } from 'react';
import classnames from 'classnames';
import { Text, Flex, Label, Content, Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import { DataSources } from '@leverege/ui-attributes';
import Loading from './Loading';
import DeviceInput from '../installGateway/DeviceInput';
import DeviceSearch from './DeviceSearch';
import S from './Pair.css';
import Util from '../../../views/salesFlow/Util';
import TagUnactivated from './TagUnactivated';
import TagLowBattery from './TagLowBattery';
import { getCompanyAndLocationIdsFromUrl } from '../../../util/Url';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PairForm(props) {
  const {
    keyId,
    tagId,
    keyDevice,
    tag,
    onChange: pOnChange,
    onPair: pOnPair,
    onUnpair: pOnUnpair,
    areaClassName,
    footerClassName,
    onClose,
    titleVariant,
    titleIcon,
    actions,
    targetKeyId,
    targetTagId,
    systemId,
    companyId
  } = props;
  const [activeScreen, setActiveScreen] = useState('main');
  const [activeField, setActiveField] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [searchTagId, setSearchTagId] = useState();
  const onClick = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  }, [setActiveScreen, setActiveField]);
  const onFocusKey = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const onFocusTag = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
    setActiveField(data.field);
  });
  const getTag = async tagId => {
    const interfaceUrl = actions.getInterfaceUrl();
    const {
      locationId
    } = getCompanyAndLocationIdsFromUrl(interfaceUrl);
    // get location action and search tag from there to allow usage from multiple levels
    const loc = {
      id: locationId,
      type: 'location',
      ref: `${systemId}/company/${companyId}/locations`
    };
    const locationActions = DataSources.getActions(loc);
    let tag;
    try {
      tag = await GlobalState.dispatch(locationActions.child('tags').itemActions(tagId).get());
    } catch (err) {
      console.error('Could not get tag imagine device', {
        err,
        tagId
      });
    }
    return tag;
  };
  const onChange = useCallback(async evt => {
    const {
      data,
      original
    } = evt;
    if (!data) {
      setActiveScreen('main');
      setActiveField(null);
      pOnChange(evt);
      return;
    }
    // check if its a tag and if so check its health conditions
    if (data === 'tagId') {
      const selectedTagId = original.id;
      const tag = await getTag(selectedTagId);
      // check health conditions of tag selected (unactivated, offline, or low battery)
      if (tag && !Util.isTagActivated(tag)) {
        setActiveScreen('tagUnactivated');
        setActiveField(null);
        setSearchTagId(selectedTagId);
        pOnChange(evt);
        return;
      }
      if (tag && Util.isTagLowBattery(tag)) {
        setActiveScreen('tagLowBattery');
        setActiveField(null);
        setSearchTagId(selectedTagId);
        console.log('here', selectedTagId);
        pOnChange(evt);
        return;
      }
    }
    setActiveScreen('main');
    setActiveField(null);
    pOnChange(evt);
  }, [pOnChange]);
  useEffect(() => {
    let preloadTarget;
    if (targetKeyId) {
      preloadTarget = {
        type: 'keys',
        id: targetKeyId
      };
    }
    if (targetTagId) {
      preloadTarget = {
        type: 'tags',
        id: targetTagId
      };
    }
    if (preloadTarget) {
      if (actions.parent().id) {
        actions.parent().child('keys');
        GlobalState.dispatch(actions.parent().child(preloadTarget.type).itemActions(preloadTarget.id).get()).then(result => {
          const evt = {
            original: result,
            value: result.name,
            data: targetTagId ? 'tagId' : 'keyId'
          };
          onChange(evt);
        });
        if (tag?.data?.key?.id) {
          GlobalState.dispatch(actions.parent().child(preloadTarget.type).itemActions(tag?.data?.key?.id).get());
        }
        if (keyDevice?.data?.tag?.id) {
          GlobalState.dispatch(actions.parent().child(preloadTarget.type).itemActions(keyDevice?.data?.tag?.id).get());
        }
      } else {
        GlobalState.dispatch(actions.get()).then(result => {
          const evt = {
            original: result,
            value: result.name,
            data: targetTagId ? 'tagId' : 'keyId'
          };
          onChange(evt);
        });
      }
    }
  }, []);
  const onPair = useCallback(async evt => {
    setLoading(true);
    try {
      await pOnPair();
      setActiveScreen('pairSuccess');
    } catch (err) {
      setError(err);
      setActiveScreen('pairFail');
    }
    setTimeout(() => setLoading(false), 250);
  }, [pOnPair]);
  const onUnpair = useCallback(async evt => {
    setLoading(true);
    try {
      await pOnUnpair();
      setActiveScreen('unpairSuccess');
    } catch (err) {
      setError(err);
      setActiveScreen('unpairFail');
    }
    setTimeout(() => setLoading(false), 250);
  }, [pOnUnpair]);
  const testExistingPairing = async evt => {
    const {
      data: {
        tag,
        key
      }
    } = evt;
    const {
      systemId
    } = props;
    if (tag?.data?.key || key?.data?.tag) {
      if (tag?.data?.key) {
        if (actions.parent().id) {
          let oldKeyGroupActions;
          if (actions.relationship.objectType === 'key') {
            oldKeyGroupActions = actions;
          } else {
            oldKeyGroupActions = actions.parent().child('keys');
          }
          try {
            // pull the old tag into state so that the name
            // can be displayed later
            await GlobalState.dispatch(oldKeyGroupActions.itemActions(tag?.data?.key.id).get());
          } catch (err) {
            console.log(`Could not retrieve old key ${tag?.data?.key.id}:`, err);
          }
        } else {
          let oldKeyGroupActions;
          if (actions.relationship.objectType === 'key') {
            try {
              // pull the old tag into state so that the name
              // can be displayed later
              await GlobalState.dispatch(oldKeyGroupActions.itemActions(tag?.data?.key.id).get());
            } catch (err) {
              console.log(`Could not retrieve old key ${tag?.data?.key.id}:`, err);
            }
          } else {
            try {
              // pull the old tag into state so that the name
              // can be displayed later
              await GlobalState.dispatch(async (dispatch, getState, {
                api
              }) => {
                api.interface(systemId, 'key').obj(tag?.data?.key.id).get();
              });
            } catch (err) {
              console.log(`Could not retrieve old key ${tag?.data?.key.id}:`, err);
            }
          }
        }
      }
      setActiveScreen('AlreadyPaired');
    } else {
      onPair();
    }
  };
  const getSearchText = useCallback(selected => {
    if (activeField === 'tagId') {
      return selected?.name || selected?.data?.macAddress;
    }
    return selected?.data?.name || selected?.name || selected?.data?.keyId;
  }, [activeField]);
  const goTo = useCallback(({
    data
  }) => {
    let action, primaryId, secondaryType, secondaryId;
    if (actions.relationship.objectType === 'key') {
      primaryId = keyDevice?.id;
      secondaryId = tag?.id;
      secondaryType = 'tag';
    } else {
      primaryId = tag?.id;
      secondaryId = keyDevice?.id;
      secondaryType = 'key';
    }
    secondaryType = `${secondaryType}s`;
    if (actions.relationship.objectType === data) {
      action = actions.goTo(primaryId);
    } else if (actions.parent().id) {
      action = actions.parent().child(secondaryType).goTo(secondaryId);
    } else {
      action = actions.parent().parent().child(secondaryType).goTo(secondaryId);
    }
    if (action) {
      GlobalState.dispatch(action);
    }
    onClose();
  }, [keyDevice, tag, actions]);
  if (loading) {
    return /*#__PURE__*/_jsx(Content, {
      variant: "pairingContent|rootEditor",
      children: /*#__PURE__*/_jsx(Content.Area, {
        variant: "formBody",
        className: classnames(S.loadingArea, areaClassName),
        children: /*#__PURE__*/_jsx(Loading, {
          message: keyDevice?.data?.tag && !tag || tag?.data?.key && !keyDevice ? 'Unpairing' : 'Pairing'
        })
      })
    });
  }
  let header;
  let content;
  let contentOverflow = {
    overflow: 'unset'
  };
  let footer;
  let body = null;
  switch (activeScreen) {
    case 'search':
      {
        const {
          [activeField]: val
        } = props;
        body = /*#__PURE__*/_createElement(DeviceSearch, {
          ...props,
          key: activeField,
          eventData: activeField,
          value: val,
          onChange: onChange,
          onClick: onClick,
          getSearchText: getSearchText
        });
        break;
      }
    case 'AlreadyPaired':
      contentOverflow = {
        overflow: 'auto'
      };
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Already installed",
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("img", {
          className: S.successImage,
          width: 120,
          height: 120,
          alt: "failed to pair",
          src: "https://recovr-ui-assets.storage.googleapis.com/pair-question.png"
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colXL",
          align: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: "Already Paired"
          }), /*#__PURE__*/_jsx(AlreadyPairedMessage, {
            tag: tag,
            keyDevice: keyDevice
          })]
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onPair,
          children: "Continue"
        })]
      });
      break;
    case 'pairSuccess':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Successfully Paired",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "successfully paired",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-success.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Success"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              tagId: tagId,
              keyId: keyId,
              error: error
            }), /*#__PURE__*/_jsxs("div", {
              className: S.buttonContainer,
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "key",
                onClick: goTo,
                children: keyId
              }), /*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: "tag",
                onClick: goTo,
                children: tagId
              })]
            })]
          })]
        });
        footer = /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: "Done"
        });
        break;
      }
    case 'unpairSuccess':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Successfully Unpaired",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "successfully paired",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-success.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Success"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              tagId: tagId,
              keyId: keyId,
              error: error
            }), /*#__PURE__*/_jsx("div", {
              className: S.buttonContainer,
              children: /*#__PURE__*/_jsx(Button, {
                variant: "fakeList",
                eventData: tag ? 'tag' : 'key',
                onClick: goTo,
                children: tag ? tagId : keyId
              })
            })]
          })]
        });
        footer = /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: "Done"
        });
        break;
      }
    case 'pairFail':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Failed to Pair",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "failed to pair",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-failure.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Failure"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              tagId: tagId,
              keyId: keyId,
              error: error
            })]
          })]
        });
        footer = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            variant: "secondary",
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            disabled: !keyId || !tagId || loading,
            onClick: onPair,
            children: "Try Again"
          })]
        });
        break;
      }
    case 'unpairFail':
      {
        header = /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Failed to Unpair",
          icon: titleIcon
        });
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("img", {
            className: S.successImage,
            width: 120,
            height: 120,
            alt: "failed to pair",
            src: "https://recovr-ui-assets.storage.googleapis.com/pair-failure.png"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colXL",
            align: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Failure"
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              tagId: tagId,
              keyId: keyId,
              error: error
            })]
          })]
        });
        footer = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            variant: "secondary",
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            disabled: !keyId || !tagId || loading,
            onClick: onPair,
            children: "Try Again"
          })]
        });
        break;
      }
    case 'tagUnactivated':
      {
        body = /*#__PURE__*/_jsx(TagUnactivated, {
          onSetField: pOnChange,
          onOkay: onChange,
          ...props
        });
        break;
      }
    case 'tagLowBattery':
      {
        body = /*#__PURE__*/_jsx(TagLowBattery, {
          onSetField: pOnChange,
          onOkay: onChange,
          getTag: getTag,
          searchTagId: searchTagId,
          ...props
        });
        break;
      }
    default:
      contentOverflow = {
        overflow: 'auto'
      };
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Pair/Unpair",
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "formTitle",
          children: "Pair/Unpair Tag to Key"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "Select Key and Tag for pairing or just one for unpairing."
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Key"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Key",
          eventData: "keyId",
          value: keyId,
          onChange: onChange,
          onFocus: onFocusKey,
          onClick: onClick,
          scanEnabled: false
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Tag ID"
        }), /*#__PURE__*/_jsx(DeviceInput, {
          hint: "Search Tag ID",
          eventData: "tagId",
          value: tagId,
          onChange: onChange,
          onFocus: onFocusTag,
          onClick: onClick,
          scanEnabled: false
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), keyDevice?.data?.tag?.id && !tag || tag?.data?.key?.id && !keyDevice ? /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !keyDevice?.data?.tag?.id && !tag?.data?.key?.id || loading,
          eventData: {
            tag,
            key: keyDevice
          },
          onClick: onUnpair,
          children: "Unpair"
        }) : /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !keyId || !tagId || loading,
          eventData: {
            tag,
            key: keyDevice
          },
          onClick: testExistingPairing,
          children: "Pair"
        })]
      });
  }
  return /*#__PURE__*/_jsxs(Content, {
    variant: "pairingContent|rootEditor",
    children: [header && /*#__PURE__*/_jsxs(Content.Header, {
      variant: "formHeader",
      children: [header, /*#__PURE__*/_jsx(Button, {
        variant: "pairClose",
        className: S.close,
        onClick: onClose
      })]
    }), content && /*#__PURE__*/_jsx(Content.Area, {
      variant: "formBody",
      className: areaClassName,
      style: contentOverflow,
      children: content
    }), footer && /*#__PURE__*/_jsx(Content.Footer, {
      variant: "formButtons",
      className: classnames(S.footer, footerClassName),
      layout: "flex:rowMEnd",
      children: footer
    }), body]
  });
}
function ErrorMessage(props) {
  const {
    error,
    tagId,
    keyId
  } = props;
  if (!error) {
    return null;
  }
  if (error.status === 400) {
    return /*#__PURE__*/_jsxs(Text, {
      children: ["Tag ", /*#__PURE__*/_jsx("b", {
        children: tagId
      }), " was unable to pair with Key ", /*#__PURE__*/_jsx("b", {
        children: keyId
      }), "."]
    });
  }
  return /*#__PURE__*/_jsxs(Text, {
    children: ["Tag ", /*#__PURE__*/_jsx("b", {
      children: tagId
    }), " was unable to pair with Key ", /*#__PURE__*/_jsx("b", {
      children: keyId
    }), " because of a network connection failure"]
  });
}
function AlreadyPairedMessage(props) {
  const {
    tag,
    keyDevice
  } = props;
  console.log('Already Paired Devices', {
    tag,
    keyDevice
  });
  const {
    models: {
      lookup
    }
  } = GlobalState.get();
  const oldTagId = keyDevice?.data?.tag?.id;
  const oldTagName = keyDevice?.data?.tag?.data?.macAddress?.slice(6)?.toUpperCase() || lookup[oldTagId]?.name || '( Unknown Tag )';
  const newTagId = tag?.id;
  const newTagName = tag?.name || '( Unknown Tame )';
  const oldKeyId = tag?.data?.key?.id;
  const newKeyName = keyDevice?.data?.keyId || '( Unknown Key )';
  let content = '';

  // repair
  if (oldTagId && oldTagId === newTagId) {
    content = `${newTagName} is already paired to ${newKeyName}.`;
  } else {
    // new tag already installed elsewhere
    if (oldKeyId) {
      const {
        models: {
          lookup
        }
      } = GlobalState.get();
      const oldKeyName = lookup[oldKeyId]?.name || '( Unknown Key )';
      content = `${newTagName} is already paired to ${oldKeyName}`;
    }
    if (oldKeyId && oldTagId) {
      content = `${content}, and `;
    }

    // new tag already has a tag
    if (oldTagId) {
      content = `${content}${oldTagName} is already paired to ${newKeyName}`;
    }
    content = `${content}. Continuing pairing will unpair `;
    if (oldTagId) {
      content = `${content}${oldTagName}`;
    }
    if (oldKeyId && oldTagId) {
      content = `${content} and `;
    }
    if (oldKeyId) {
      content = `${content}${newTagName}`;
    }
    content = `${content}, and pair ${newTagName} to ${newKeyName}.`;
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      children: content
    }), /*#__PURE__*/_jsx(Text, {
      children: "Continue Pairing?"
    })]
  });
}